<template>
  <div class="working-hours">
    <p
      class="working-hours-verdict"
      v-show="!showWorkingHours"
    >
      Время работы:<br>
      <a
        v-bind:class="areWorkingNowClass"
        v-on:click="showWorkingHours=true"
      >
        {{(areWorkingNow)? 'сейчас открыто' : 'сейчас закрыто' }}
       </a>
    </p>
    <transition-height-expand>
      <div
        class="working-hours-table-wrapper"
        v-show="showWorkingHours"
      >
        <table v-bind:class="['working-hours-table', areWorkingNowClass]">
          <caption>График работы:</caption>
          <tr
            class="row"
            v-for="wh in workingHoursDisplay"
            v-bind:key="wh.day_of_week"
            v-bind:itemprop="isWorkingDay(wh) ? 'openingHours' : null"
            v-bind:content="getMicroData(wh)"
          >
            <td class="cell">{{ getWeekDayName(wh.day_of_week) }}</td>
            <td
              class="cell"
              v-if="isWorkingDay(wh)"
            >
              {{ formatHour(wh.from_hour) }} – {{ formatHour(wh.to_hour) }}
            </td>
            <td
              class="cell"
              v-else
            >
              Выходной
            </td>
            <td
              class="cell"
              v-if="wh.note"
            >
              {{ wh.note }}
            </td>
          </tr>
        </table>
      </div>
    </transition-height-expand>
  </div>
</template>

<script>
import TransitionHeightExpand from '@/components/utils/TransitionHeightExpand'

export default {
  name: 'ContactsWorkingHours',
  props: ['working-hours'],
  components: {TransitionHeightExpand},
  data () {
    return {
      currentDayOfWeek: 1,
      workingHoursDisplay: [],
      areWorkingNow: true,
      showWorkingHours: false,
      timerId: '',
      dayOfWeekCodes: {
        'Понедельник': 'Mo',
        'Вторник': 'Tue',
        'Среда': 'We',
        'Четверг': 'Th',
        'Пятница': 'Fr',
        'Суббота': 'Sa',
        'Воскресенье': 'Su'
      }
    }
  },
  created () {
    this.timerId = setInterval(this.updateWorkingHoursInfo, 60000) // update each minute
  },
  mounted () {
    this.updateWorkingHoursInfo()
  },
  beforeDestroy () {
    clearInterval(this.timerId)
  },
  computed: {
    areWorkingNowClass: function () {
      return (this.areWorkingNow) ? 'working-now' : 'not-working-now'
    }
  },
  methods: {
    getWeekDayName: function (weekDayNumber) {
      const weekDayNames = [
        'Понедельник', 'Вторник', 'Среда', 'Четверг',
        'Пятница', 'Суббота', 'Воскресенье']
      return weekDayNames[weekDayNumber - 1]
    },
    formatHour: function (timeString) {
      // timeString is a string of a format HH:MM:SS
      // omit seconds and trim zeros at the beginning
      return timeString.split(':').slice(0, 2).join(':').replace(/^0+/, '')
    },
    replaceTime: function (datetimeString, newTimeString) {
      const timePattern = /\d{2}:\d{2}:\d{2}/
      return datetimeString.replace(timePattern, newTimeString)
    },
    isWorkingDay: function (wh) {
      return wh.from_hour && wh.to_hour
    },
    getMicroData: function (wh) {
      if (this.isWorkingDay(wh)) {
        const dayName = this.getWeekDayName(wh.day_of_week)
        const dayCode = this.dayOfWeekCodes[dayName]
        const fromHour = this.formatHour(wh.from_hour)
        const toHour = this.formatHour(wh.to_hour)
        return `${dayCode} ${fromHour}-${toHour}`
      } else {
        return null
      }
    },
    updateWorkingHoursDisplay: function () {
      const pivot = this.currentDayOfWeek - 1
      this.workingHoursDisplay = this.workingHours.slice(pivot)
        .concat(this.workingHours.slice(0, pivot))
    },
    updateCurrentDayOfWeek: function () {
      // 0 is Sunday, 1 is Monday, etc.
      const dayOfWeek = new Date().getDay()
      this.currentDayOfWeek = (dayOfWeek === 0) ? 7 : dayOfWeek
    },
    updateAreWorkingNow: function () {
      const currentWorkingHours = this.workingHours[this.currentDayOfWeek - 1]
      if (currentWorkingHours.from_hour && currentWorkingHours.to_hour) {
        const currentDatetime = new Date()
        const startDatetime = new Date(this.replaceTime(
          currentDatetime.toString(), currentWorkingHours.from_hour))
        const endDatetime = new Date(this.replaceTime(
          currentDatetime.toString(), currentWorkingHours.to_hour))

        this.areWorkingNow = (
          (startDatetime <= currentDatetime) &&
          (currentDatetime <= endDatetime))
      } else {
        this.areWorkingNow = false // this is a day-off
      }
    },
    updateWorkingHoursInfo: function () {
      this.updateCurrentDayOfWeek()
      this.updateWorkingHoursDisplay()
      this.updateAreWorkingNow()
    }
  }
}
</script>

<style scoped lang="scss">
  .working-hours {
    .working-hours-verdict {
      line-height: normal;
      a {
        text-decoration: underline;
        &.working-now { color: green; }
        &.not-working-now { color: red; }
        &:after {
          content: "▼";
          font-size: 0.75em;
          margin-top: -0.25em;
        }
      }
      @media only print {
        display: none !important;
      }
    }
    .working-hours-table-wrapper {
      @media only print {
        display: block !important;
      }
    }
    .working-hours-table {
      border-collapse: collapse;
      text-align: left;
      display: table;
      margin: 0 auto;
      & > caption {
        @include media (">tablet") {
          text-align: right;
        }
      }
      .row {
        display: table-row;
        .cell {
          display: table-cell;
          padding-right: 1em;
          &:last-child { padding-right: 0; }
        }
      }
      &.working-now {
        .row:nth-child(2) {
          color: green;
        }
      }
      &.not-working-now {
        .row:nth-child(2) {
          color: red;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/the-content/ContactsWorkingHours.vue